import PropTypes from "prop-types"
import { capitalize } from "humanize-plus"
import classnames from "classnames"
import Spinner from "shared/components/spinner"

import checkSVG from "images/components/check2.svg"
import "./applet_configuration.scss"

const CollapsedConfigItem = ({
  type,
  title = "",
  status,
  index,
  onRemoveClick,
  onUpdateViewClick,
  appletUpdating,
}) => (
  <div styleName="feature">
    <span styleName="feature-title-group">
      {status === "validating" ? (
        <Spinner
          config={{
            left: "-5.3em",
            bottom: "0%",
            length: 3,
            width: 3,
            radius: 10,
            corners: 0,
            scale: 0.55,
            position: "relative",
          }}
        />
      ) : (
        <span
          styleName={classnames("validation-status", {
            dirty: status === "dirty",
          })}
          dangerouslySetInnerHTML={{
            __html: status === "valid" ? checkSVG : "!",
          }}
        />
      )}
      <div>
        <span styleName="feature-index">
          {capitalize(type)} {index}
        </span>
        <span styleName="feature-title">{title}</span>
      </div>
    </span>
    <span styleName="feature-button-group">
      <button
        className="button-tertiary button-outlined"
        type="button"
        onClick={() => onUpdateViewClick(true)}
        disabled={appletUpdating}
      >
        Configure
      </button>
      <a
        styleName="remove-config"
        onClick={e =>
          confirm(`Are you sure you want to remove this ${type}?`) &&
          onRemoveClick(e)
        }
        data-open-in-current-window={true}
      >
        Remove
      </a>
    </span>
  </div>
)

CollapsedConfigItem.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  status: PropTypes.oneOf(["valid", "dirty", "validating"]),
  index: PropTypes.number.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onUpdateViewClick: PropTypes.func.isRequired,
  appletUpdating: PropTypes.bool.isRequired,
}

CollapsedConfigItem.defaultProps = {
  appletUpdating: false,
}

export default CollapsedConfigItem
